import { defineMessages } from '../messages'

export const shellMessages = defineMessages(
  {
    roleUser: 'Notandi',
    toggleMenu: 'Fella valmynd',
    searchCustomer: 'Leita að viðskiptavini…',
    toggleTheme: 'Skipta um þema',
    logout: 'Skrá út',
    myArea: 'Mitt svæði',
    doneCustomizing: 'Búið að sérsníða',
    customizeMenu: 'Sérsníða valmynd',
    superadminAccess: 'Superadmin aðgangur',
    adminAccess: 'Stjórnandi aðgangur',
    superadminAccessBody: 'Þú hefur fullan aðgang að öllum viðskiptavinum og virkni.',
    adminAccessBody: 'Þú hefur aðgang að notendum og virkni þinna viðskiptavina.',
    dragToReorder: 'Draga til að endurraða',
    showInMenu: 'Sýna í valmynd',
    hideFromMenu: 'Fela úr valmynd',
    searchCustomerLabel: 'Leita að viðskiptavini',
    searchPlaceholder: 'Leita að viðskiptavini eftir nafni eða kennitölu…',
    noCustomerFound: 'Enginn viðskiptavinur fannst.',
    startTyping: 'Byrjaðu að skrifa til að leita.',
    svrRegistry: 'Viðskiptaskrá ÍGF (SVR)',
    fetchAndOpen: 'Sækja og opna →',
    footerTagline: 'Gagnadrifnar lausnir fyrir betri ákvarðanatöku',
    footerVersionTitle: 'Útgáfan sem er í loftinu',
    version: (v: string) => `Útgáfa ${v}`,
  },
  {
    en: {
      roleUser: 'User',
      toggleMenu: 'Collapse menu',
      searchCustomer: 'Search for a customer…',
      toggleTheme: 'Switch theme',
      logout: 'Log out',
      myArea: 'My area',
      doneCustomizing: 'Done customising',
      customizeMenu: 'Customise menu',
      superadminAccess: 'Superadmin access',
      adminAccess: 'Administrator access',
      superadminAccessBody: 'You have full access to all customers and features.',
      adminAccessBody: "You have access to your customers' users and activity.",
      dragToReorder: 'Drag to reorder',
      showInMenu: 'Show in menu',
      hideFromMenu: 'Hide from menu',
      searchCustomerLabel: 'Search for a customer',
      searchPlaceholder: 'Search for a customer by name or ID number…',
      noCustomerFound: 'No customer found.',
      startTyping: 'Start typing to search.',
      svrRegistry: 'ÍGF customer register (SVR)',
      fetchAndOpen: 'Fetch and open →',
      footerTagline: 'Data-driven solutions for better decision-making',
      footerVersionTitle: 'Version currently live',
      version: (v: string) => `Version ${v}`,
    },
    pl: {
      roleUser: 'Użytkownik',
      toggleMenu: 'Zwiń menu',
      searchCustomer: 'Szukaj klienta…',
      toggleTheme: 'Zmień motyw',
      logout: 'Wyloguj się',
      myArea: 'Mój obszar',
      doneCustomizing: 'Zakończ dostosowywanie',
      customizeMenu: 'Dostosuj menu',
      superadminAccess: 'Dostęp superadministratora',
      adminAccess: 'Dostęp administratora',
      superadminAccessBody: 'Masz pełny dostęp do wszystkich klientów i funkcji.',
      adminAccessBody: 'Masz dostęp do użytkowników i aktywności swoich klientów.',
      dragToReorder: 'Przeciągnij, aby zmienić kolejność',
      showInMenu: 'Pokaż w menu',
      hideFromMenu: 'Ukryj w menu',
      searchCustomerLabel: 'Szukaj klienta',
      searchPlaceholder: 'Szukaj klienta po nazwie lub numerze identyfikacyjnym (kennitala)…',
      noCustomerFound: 'Nie znaleziono klienta.',
      startTyping: 'Zacznij pisać, aby wyszukać.',
      svrRegistry: 'Rejestr klientów ÍGF (SVR)',
      fetchAndOpen: 'Pobierz i otwórz →',
      footerTagline: 'Rozwiązania oparte na danych dla lepszych decyzji',
      footerVersionTitle: 'Aktualnie wdrożona wersja',
      version: (v: string) => `Wersja ${v}`,
    },
  }
)

export const navMessages = defineMessages(
  {
    dashboard: 'Mælaborð',
    customers: 'Viðskiptavinir',
    users: 'Notendur',
    'access-requests': 'Aðgangsumsóknir',
    companies: 'Fyrirtæki',
    adminSettings: 'Admin stillingar',
    mailpit: 'Mailpit',
    activity: 'Virkni',
    zeroCollections: 'Núll-losanir',
    unknownMaterials: 'Óþekkt vörunúmer',
    verkefni: 'Verkefnalisti',
    settings: 'Stillingar',
  },
  {
    en: {
      dashboard: 'Dashboard',
      customers: 'Customers',
      users: 'Users',
      'access-requests': 'Access requests',
      companies: 'Companies',
      adminSettings: 'Admin settings',
      mailpit: 'Mailpit',
      activity: 'Activity',
      zeroCollections: 'Zero collections',
      unknownMaterials: 'Unknown material ids',
      verkefni: 'Request list',
      settings: 'Settings',
    },
    pl: {
      dashboard: 'Pulpit',
      customers: 'Klienci',
      users: 'Użytkownicy',
      'access-requests': 'Wnioski o dostęp',
      companies: 'Firmy',
      adminSettings: 'Ustawienia administratora',
      mailpit: 'Mailpit',
      activity: 'Aktywność',
      zeroCollections: 'Odbiory zerowe',
      unknownMaterials: 'Nieznane kody materiałów',
      verkefni: 'Lista zgłoszeń',
      settings: 'Ustawienia',
    },
  }
)
